<dx-chart id="chart" title="Transfered invoices/invoicelines/accounts" [dataSource]="jobStatisticsData$ | async">
    <dxo-argument-axis
        [aggregationGroupWidth]="100"> <!-- A new interval every 100 pixels -->
    </dxo-argument-axis>
    <dxi-series type="bar" valueField="totalInvoicesTransferedSuccessfully" color="#00C851" name="Successfully invoice transfers"></dxi-series>
    <dxi-series type="bar" valueField="totalInvoicesTransferedFailed" color="#ff4444" name="Failed invoice transfers" ></dxi-series>
    <dxi-series type="bar" valueField="totalInvoiceLinesTransferedSuccessfully" color="#00A951" name="Successfully invoice line transfers"></dxi-series>
    <dxi-series type="bar" valueField="totalInvoiceLinesTransferedFailed" color="#FF6444" name="Failed invoice line transfers"></dxi-series>

    <dxo-common-series-settings argumentField="jobDateTime" type="bar">
        <dxo-label [visible]="true" [showForZeroValues]="false">
            <dxo-format type="largeNumber" [precision]="2"></dxo-format>
        </dxo-label>
    </dxo-common-series-settings>

    <dxo-argument-axis argumentType="datetime" tickInterval="day" >
        <dxo-label [format]="{ type: 'dd/MM/yyyy' }"></dxo-label>
    </dxo-argument-axis>
    <dxo-legend verticalAlignment="bottom" horizontalAlignment="center">
    </dxo-legend>
    <dxo-tooltip
    [enabled]="true"
    [shared]="true"
    [customizeTooltip]="customizeTooltip"
  >
  </dxo-tooltip>
</dx-chart>

<dx-range-selector
  id="range-selector"
  [value]="[selectedStartValue, selectedEndValue]"
  title="Select the period"
  (onValueChanged)="handleScaleValueChange($event)"
>
  <dxo-scale
    [(startValue)]="selectedStartValue"
    [(endValue)]="selectedEndValue"
    minorTickInterval="day"
    tickInterval="week"
    minRange="week"
    maxRange="month"
  >
  </dxo-scale>
  <dxo-slider-marker format="monthAndDay"></dxo-slider-marker>
</dx-range-selector>

<div></div>
